import React from 'react';
import addImages from "../img/plus.png";

const Imges = {
    add:addImages
}

export default Imges;